module.exports = __webpack_public_path__ + "static/media/logo.9600801a.svg";